export default function numberFormat(numPrice) {
  return `${numPrice}`.replace('.', ',');
}
